/* TestHelden · Lerngruppen (/pages/lerngruppen): Reiter im Einblick (WAI-ARIA Tabs, Pfeiltasten, Pos1/Ende) und
   „Weitere Lerngruppen zeigen“ (nur mobil gekürzt; ohne JS sind alle Gruppen sichtbar). Idempotent. */
(function () {
  'use strict';
  if (window.__thLg) return;
  window.__thLg = true;

  function tabs(liste) {
    if (liste.dataset.lgBereit) return;
    liste.dataset.lgBereit = '1';
    var reiter = Array.prototype.slice.call(liste.querySelectorAll('[role="tab"]'));
    var karte = liste.closest('[data-lg-einblick]') || document;
    function zeige(i, fokus) {
      reiter.forEach(function (r, j) {
        var an = i === j;
        r.setAttribute('aria-selected', an ? 'true' : 'false');
        r.tabIndex = an ? 0 : -1;
        var p = karte.querySelector('#' + r.getAttribute('aria-controls'));
        if (p) p.classList.toggle('ist-aktiv', an);
      });
      if (fokus) reiter[i].focus();
      var r = reiter[i];
      if (r && liste.scrollWidth > liste.clientWidth) {
        var links = r.offsetLeft - liste.offsetLeft;
        liste.scrollTo({ left: Math.max(0, links - 16), behavior: 'smooth' });
      }
    }
    reiter.forEach(function (r, i) {
      r.addEventListener('click', function () { zeige(i, false); });
      r.addEventListener('keydown', function (e) {
        var n = reiter.length, z = null;
        if (e.key === 'ArrowRight') z = (i + 1) % n;
        else if (e.key === 'ArrowLeft') z = (i - 1 + n) % n;
        else if (e.key === 'Home') z = 0;
        else if (e.key === 'End') z = n - 1;
        if (z !== null) { e.preventDefault(); zeige(z, true); }
      });
    });
  }

  function mehr(liste) {
    if (liste.dataset.lgBereit) return;
    liste.dataset.lgBereit = '1';
    var grenze = parseInt(liste.getAttribute('data-lg-mobil'), 10) || 6;
    var eintraege = liste.children;
    if (eintraege.length <= grenze) return;
    var knopf = liste.parentNode.querySelector('[data-lg-mehr]');
    if (!knopf) return;
    for (var i = grenze; i < eintraege.length; i++) eintraege[i].classList.add('ist-mehr');
    liste.setAttribute('data-gekuerzt', '');
    knopf.hidden = false;
    knopf.addEventListener('click', function () {
      liste.removeAttribute('data-gekuerzt');
      knopf.setAttribute('aria-expanded', 'true');
      knopf.hidden = true;
      var erster = eintraege[grenze] && eintraege[grenze].querySelector('a');
      if (erster) erster.focus({ preventScroll: true });
    });
  }

  function start() {
    document.querySelectorAll('[data-lg-tabs]').forEach(tabs);
    document.querySelectorAll('[data-lg-mehr-liste]').forEach(mehr);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener("shopify:section:load", start);
})();
